/* tslint:disable */
/* eslint-disable */
/**
 * Pricing API
 * API for managing pricing.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GuaranteeDto1 } from './GuaranteeDto1';
import {
    GuaranteeDto1FromJSON,
    GuaranteeDto1FromJSONTyped,
    GuaranteeDto1ToJSON,
    GuaranteeDto1ToJSONTyped,
} from './GuaranteeDto1';

/**
 * 
 * @export
 * @interface GuaranteeReferentialDto1
 */
export interface GuaranteeReferentialDto1 {
    /**
     * 
     * @type {Array<GuaranteeDto1>}
     * @memberof GuaranteeReferentialDto1
     */
    optional: Array<GuaranteeDto1>;
    /**
     * 
     * @type {Array<GuaranteeDto1>}
     * @memberof GuaranteeReferentialDto1
     */
    mandatory: Array<GuaranteeDto1>;
}

/**
 * Check if a given object implements the GuaranteeReferentialDto1 interface.
 */
export function instanceOfGuaranteeReferentialDto1(value: object): value is GuaranteeReferentialDto1 {
    if (!('optional' in value) || value['optional'] === undefined) return false;
    if (!('mandatory' in value) || value['mandatory'] === undefined) return false;
    return true;
}

export function GuaranteeReferentialDto1FromJSON(json: any): GuaranteeReferentialDto1 {
    return GuaranteeReferentialDto1FromJSONTyped(json, false);
}

export function GuaranteeReferentialDto1FromJSONTyped(json: any, ignoreDiscriminator: boolean): GuaranteeReferentialDto1 {
    if (json == null) {
        return json;
    }
    return {
        
        'optional': ((json['optional'] as Array<any>).map(GuaranteeDto1FromJSON)),
        'mandatory': ((json['mandatory'] as Array<any>).map(GuaranteeDto1FromJSON)),
    };
}

export function GuaranteeReferentialDto1ToJSON(json: any): GuaranteeReferentialDto1 {
    return GuaranteeReferentialDto1ToJSONTyped(json, false);
}

export function GuaranteeReferentialDto1ToJSONTyped(value?: GuaranteeReferentialDto1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'optional': ((value['optional'] as Array<any>).map(GuaranteeDto1ToJSON)),
        'mandatory': ((value['mandatory'] as Array<any>).map(GuaranteeDto1ToJSON)),
    };
}

